import { baseUrl } from '@fs/zion-config'
import { type GroupId } from '@fs/zion-tree-types'

const getCheckedBaseUrl = (): string => {
  const prodBaseUrl = 'https://www.familysearch.org'
  const betaBaseUrl = 'https://beta.familysearch.org'
  const intBaseUrl = 'https://integration.familysearch.org'

  if (!baseUrl || (baseUrl !== prodBaseUrl && baseUrl !== betaBaseUrl && baseUrl !== intBaseUrl)) {
    return prodBaseUrl
  }
  return baseUrl
}

type Props = {
  turnOnExp?: boolean
  isCet?: boolean
  groupId: GroupId
  inviteId: string
}

export default function createInviteLink({ isCet, groupId, inviteId, turnOnExp }: Props): string {
  const groupType = isCet ? 'research-tree' : 'family'
  let expParam = ''
  if (turnOnExp && isCet) {
    expParam = '&cet_test=true'
  }
  return `${getCheckedBaseUrl()}/groups/${groupType}?groupId=${groupId}&inviteId=${inviteId}${expParam}`
}
